import { AgGridReact } from 'ag-grid-react';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-balham.css';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { API_DOMAIN } from '../../EnvVars';
import { userIsAdmin } from '../../utils/RolesBasedUsers';
import '../../components/Dealers/Dealers.css';
import * as featureNames from '../../utils/FeatureNames';
import TickIcon from '../../components/Icons/TickIcon';
import UntickIcon from '../../components/Icons/UntickIcon';
import { renderToString } from 'react-dom/server';
import Api from '../../api/api';
let colFeatures = [];
class PaymentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowSelection: 'single',
      enableFilter: true,
      enableSorting: true,
      enableColResize: true,
      loading: true,
      columnDefs: [
        {
          headerName: 'ID (#)',
          field: 'id',
          pinned: 'left',
          valueGetter: params => `${params.data.id} (${params.data.id})`,
        },
        {
          headerName: 'IS_SEND',
          field: 'isSend',
          pinned: 'left',
          valueGetter: params => `${params.data.isSend} (${params.data.isSend})`,
        },
        {
          headerName: 'Dealer Name',
          field: 'dealerName',
          pinned: 'left',
        },
        {
          headerName: 'Location Name',
          field: 'locationName',
          pinned: 'left',
        },
        {
          headerName: 'Appointment Date',
          field: 'appointmentDate',
          pinned: 'left',
        },
        {
          headerName: 'Created Date',
          field: 'createdDate',
          pinned: 'left',
        },
        {
          headerName: 'Error History',
          field: 'errorHistory',
          pinned: 'left',
        },
      ],
      rowData: [],
      payments: [],
      authToken: localStorage.getItem('authToken'),
    };

    colFeatures = data => {
      data.forEach(payment =>
        columns.push({
          headerName: payment.displayName,
          field: payment.payment,
          width: 48,
          cellRenderer: params => {
            if (params.value === true) return renderToString(<TickIcon />);
            return renderToString(<UntickIcon />);
          },
        }),
      );
    };
  }

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      localStorage.setItem('httpOther', 'Unauthorised or Session Expired');

      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // get dealer features
    Api.getEnvironmentData()
      .then(response => {
        createRow(response);
        this.exportToJsonFile(response);
      })
      .catch(error => {
        localStorage.setItem('httpOther', error.message);
        this.props.history.push({
          pathname: '/login',
        });
      });

    // create row
    const createRow = data => {
      const rows = [];

      if (Array.isArray(data)) {
        data.forEach(payment => {
          // Set up data for the table
          const row = {
            id: payment.id,
            isSend: payment.isSend,
            dealerName: payment.dealerName,
            locationName: payment.locationName,
            appointmentDate: payment.appointmentDate,
            createdDate: payment.createdDate,
            bookingId: payment.bookingId,
            errorHistory: payment.errorHistory,
          };
          // Add all remaining data from api to be used elsewhere
          const _row = { ...payment, ...row };
          rows.push(_row);
        });
      } else {
        console.error('Data is not an array or is undefined:', data);
      }

      this.setState(
        {
          rowData: rows,
          loading: false,
        },
        this.autoSizeAll,
      ); // Ensure rows are passed and auto-size is triggered
    };
  }

  autoSizeAll = () => {
    const allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(column => {
      if (
        column.colId === 'id' ||
        column.colId === 'isSend' ||
        column.colId === 'dealerName' ||
        column.colId === 'locationName' ||
        column.colId === 'appointmentDate' ||
        column.colId === 'createdDate' ||
        column.colId === 'errorHistory'
      ) {
        allColumnIds.push(column.colId);
      }
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
  };

  onSelectionChanged = params => {
    this.gridApi = params.api;
    const selectedRows = this.gridApi.getSelectedRows();
    const selected_row = selectedRows[0];
    const payment = this.state.rowData.filter(payment => payment.id === selected_row.id)[0];
    if (payment) {
      this.setState({ payment });
      this.props.history.push({
        pathname: '/editpayment',
        state: { payment },
      });
    } else {
      console.warn('No matching Details found for selected row');
    }
  };

  exportToCSV = () => {
    const rows = [];

    const row = this.state.rowData[0];
    const arr = [];
    for (const col in row) {
      const spacedColName = insertSpaces(col);

      const result = spacedColName.toLowerCase().replace(/([A-Z])/g, ' $1');
      arr.push(result.charAt(0).toUpperCase() + result.slice(1));
    }
    rows.push(arr);

    this.state.rowData.map(row => {
      const arr = [];
      for (const col in row) {
        arr.push(row[col]);
      }
      rows.push(arr);
    });

    let csvContent = 'data:text/csv;charset=utf-8,' + rows.map(e => e.join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'PaymentRetry.csv');
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);

    function insertSpaces(word) {
      let _word = word;
      while (_word.indexOf('_') > -1) {
        _word = _word.replace('_', ' ');
      }

      // convert camel case to sentence case if word is not all caps (lazy check)
      if (!isUpperCase(_word[0]) && !isUpperCase(_word[1])) {
        return _word
          .replace(/([A-Z])/g, match => ` ${match}`)
          .replace(/^./, match => match.toUpperCase());
      }

      return _word;

      function isUpperCase(char) {
        return char >= 'A' && char <= 'Z';
      }
    }
  };

  exportToJsonFile = data => {
    const dataStr = JSON.stringify(data, null, 2);
    const dataUri = `data:application/json;charset=utf-8,${encodeURIComponent(dataStr)}`;
    const exportFileDefaultName = 'PaymentRetry.json';
    this.setState({ dataUri, exportFileDefaultName });
  };

  render() {
    const {
      loading,
      rowSelection,
      enableFilter,
      enableSorting,
      enableColResize,
      columnDefs,
      rowData,
      dataUri,
      exportFileDefaultName,
    } = this.state;
    return (
      <div className="dealerTableWrapper">
        <div id="dealerTable" className="ag-theme-balham">
          <AgGridReact
            rowSelection={rowSelection}
            enableFilter={enableFilter}
            enableSorting={enableSorting}
            enableColResize={enableColResize}
            columnDefs={columnDefs}
            rowData={rowData}
            onSelectionChanged={this.onSelectionChanged.bind(this)}
            onGridReady={this.onGridReady.bind(this)}
            overlayNoRowsTemplate={loading ? 'Fetching data...' : 'No information to display'}
            headerHeight="160"
            resizable="true"
            autoHeight="true"
          />
        </div>
        <div>
          <br />
          <span className="glyphicon glyphicon-remove featureoff" />
          <span> This feature is disabled, however it can be toggled at the Booking level.</span>
        </div>
        <br />
        <br />
        <button className={`btn btn-primary dealerEditSaveButton`}>
          <a className="buttonLink" href={dataUri} download={exportFileDefaultName}>
            Download as JSON
          </a>
        </button>
        &nbsp;&nbsp;&nbsp;
        <button className={`btn btn-primary dealerEditSaveButton`} onClick={this.exportToCSV}>
          Export to CSV
        </button>
      </div>
    );
  }
}

export default withRouter(PaymentTable);



// WEBPACK FOOTER //
// ./src/containers/PaymentDashboard/PaymentTable.js